export const KEY_NUMBERS_2_CONSTANTS = {
  /** Shown above the metrics table in admin (MAX_METRICS = 8 in KeyNumbers2.tsx). */
  METADATA_TITLES: {
    metadata:
      "Metrics (up to 8 shown on page)",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "500+",
    meta_subtitle: "Hiring Partners",
    meta_priority: 1,
    meta_title_text_color: "#FFFFFF",
    meta_subtitle_text_color: "#FFFFFFCC",
    meta_status: true,
  },

  KEY_NUMBERS_FIELDS_CONFIG: [
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Key Numbers",
      required: false,
      defaultValue: true,
    },
    
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #222222",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_3",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: false,
      defaultValue: "variant_3",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #00D4EB",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #5345C3",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "pre_title",
      label: "Pre Title (max 20 characters)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 20 characters",
      required: false,
      defaultValue: "Where Learning Meets the",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Title (max 20 characters)",
      value: "Real World",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 20 characters",
      required: false,
      defaultValue: "Real World",
    },
    {
      fieldName: "title_start_color",
      label: "Title Gradient Start Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_end_color",
      label: "Title Gradient End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #02A7B6 (optional)",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_gradient_angle",
      label: "Title Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 90deg",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "description",
      label: "Description (max 250 characters)",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Max 250 characters",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#FFFFFFB2",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFFB2",
      required: false,
      defaultValue: "#FFFFFFB2",
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    }
  ],

  METADATA_FIELDS: [
    {
      header: "Metric title (max 7 characters)",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 7 characters (e.g. 100, 500+)",
    },
    {
      header: "Title Text Color",
      fieldName: "meta_title_text_color",
      value: "#F8F9FA",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color",
      defaultValue: "#F8F9FA",
    },
    {
      header: "Metric subtitle (max 30 characters)",
      fieldName: "meta_subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 30 characters",
    },
    {
      header: "Subtitle Text Color",
      fieldName: "meta_subtitle_text_color",
      value: "#F8F9FA",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subtitle text color",
      defaultValue: "#F8F9FA",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable this item",
      defaultValue: true,
    },
  ],
};
